/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DietitianAppointmentAnonymousRequest
 */
export interface DietitianAppointmentAnonymousRequest {
    /**
     * 
     * @type {string}
     * @memberof DietitianAppointmentAnonymousRequest
     */
    'email'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DietitianAppointmentAnonymousRequest
     */
    'dietaryGoals'?: Array<DietitianAppointmentAnonymousRequestDietaryGoalsEnum>;
    /**
     * 
     * @type {string}
     * @memberof DietitianAppointmentAnonymousRequest
     */
    'additionalNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof DietitianAppointmentAnonymousRequest
     */
    'partnerId': string;
    /**
     * 
     * @type {string}
     * @memberof DietitianAppointmentAnonymousRequest
     */
    'captchaToken': string;
    /**
     * 
     * @type {string}
     * @memberof DietitianAppointmentAnonymousRequest
     */
    'fullName': string;
    /**
     * 
     * @type {string}
     * @memberof DietitianAppointmentAnonymousRequest
     */
    'dateOfBirth': string;
    /**
     * 
     * @type {string}
     * @memberof DietitianAppointmentAnonymousRequest
     */
    'gender': DietitianAppointmentAnonymousRequestGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof DietitianAppointmentAnonymousRequest
     */
    'contactNumber': string;
}

export const DietitianAppointmentAnonymousRequestDietaryGoalsEnum = {
    WeightLoss: 'WEIGHT_LOSS',
    WeightMaintenance: 'WEIGHT_MAINTENANCE',
    MuscleGain: 'MUSCLE_GAIN',
    ImprovedOverallHealth: 'IMPROVED_OVERALL_HEALTH',
    ManagementOfChronicConditions: 'MANAGEMENT_OF_CHRONIC_CONDITIONS',
    ImprovedEnergyLevels: 'IMPROVED_ENERGY_LEVELS',
    EnhancedAthleticPerformance: 'ENHANCED_ATHLETIC_PERFORMANCE',
    BalancedDietHealthyEating: 'BALANCED_DIET_HEALTHY_EATING',
    SpecificDietaryPreferences: 'SPECIFIC_DIETARY_PREFERENCES',
    PregnancyPostpartumNutrition: 'PREGNANCY_POSTPARTUM_NUTRITION',
    DigestiveHealthImprovement: 'DIGESTIVE_HEALTH_IMPROVEMENT',
    Other: 'OTHER'
} as const;

export type DietitianAppointmentAnonymousRequestDietaryGoalsEnum = typeof DietitianAppointmentAnonymousRequestDietaryGoalsEnum[keyof typeof DietitianAppointmentAnonymousRequestDietaryGoalsEnum];
export const DietitianAppointmentAnonymousRequestGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE'
} as const;

export type DietitianAppointmentAnonymousRequestGenderEnum = typeof DietitianAppointmentAnonymousRequestGenderEnum[keyof typeof DietitianAppointmentAnonymousRequestGenderEnum];


